import React from 'react'
import Modal from 'react-responsive-modal'
import Header from 'semantic-ui-react/dist/commonjs/elements/Header'
import styled from 'styled-components'

const ModalStyle = {
  modal: {
    background: '#ffff0000',
    boxShadow: 'none',
  },
}

const SkeletonSpin = styled.div`
  .lds-spinner {
    color: official;
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
  }
  .lds-spinner div:after {
    content: ' ';
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: #fff;
  }
  .lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  .lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
  }
  .lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
  }
  .lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
  }
  .lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
  }
  .lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
  }
  .lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
  }
  .lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
  }
  .lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
  }
  .lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
  }
  .lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
  }
  .lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
  }
  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`

const LoadModal = ({modalActive, title, subtitle, height = '250px'}) => {
  return (
    <Modal
      enter="scale in"
      enterDuration={1000}
      leave="scale out"
      leaveDuration={1000}
      open={modalActive}
      center
      styles={ModalStyle}
      focusTrapped={false}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      onClose={() => {}}
    >
      <Header as="h2" icon inverted>
        <SkeletonSpin height={height}>
          <div className="lds-spinner">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
        </SkeletonSpin>
        {title || 'Processing...'}
        <Header.Subheader>{subtitle || 'Please wait'}</Header.Subheader>
      </Header>
    </Modal>
  )
}

export default LoadModal
